/**
 * Creates an object containing prop bindings by extracting values from props
 * based on prop definitions and merging with optional overrides.
 *
 * @param {Object} propDefinitions - An object defining the props to extract (e.g., Vue component props definition)
 * @param {Object} props - The source props object containing actual values
 * @param {Object} [overrides={}] - Optional object to override or add additional prop bindings
 * @returns {Object} An object containing all prop bindings with values from props and overrides
 *
 * @example
 * const basePropBindings = getPropBindings(baseProps, this.$props)
 * const basePropBindings = getPropBindings(baseProps, this.$props, { disabled: true })
 */
const getPropBindings = (propDefinitions, props, overrides = {}) => ({
    ...Object.fromEntries(
        Object.keys(propDefinitions).map((propName) => [
            propName,
            props[propName],
        ])
    ),
    ...overrides,
})

export { getPropBindings }
